<template>
    <v-dialog v-model="show" persistent max-width="400" :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? $store.commit('setTelsasoftAbout', {show: false}) : null}">

        <v-card>
            <v-card-title style="font-size: 24px;">
                <img class="mr-4" src="@/assets/tsLogo.png" style="width: 44.5px; height: 36px;" /> Telsasoft
            </v-card-title>

            <v-card-text>
                Version <span style="fontWeight: bold;">{{ $store.state.applicationVersion }}</span>
                <v-btn class="ml-3 mb-1" x-small @click="showNewFeaturesClick" color="#303030">
                    <v-icon x-small color="yellow" class="mr-3">mdi-lightbulb-on</v-icon>
                    New Features
                </v-btn>
                </br>
                Copyright {{ currentYear }} Telsasoft LLC. All rights reserved.
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$store.commit('setTelsasoftAbout', {show: false})">Close</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
export default {
    name: 'TelsasoftAbout',
    props: {
        value: Boolean,
    },
    components: {
    },
    data: () => ({
        currentYear: TELSA.moment().format('YYYY')
    }),

    computed: {
        show: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value);
            }
        },
    },

    methods: {
        showNewFeaturesClick: function() {
            this.$emit('new-features');
            this.$store.commit('setTelsasoftAbout', {show: false});
        }

    },

    mounted() {

    }

  
};
</script>
